export default function ImagesSection({ children, className = "" }) {
    return (
        <div className={`mt-28 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 ${className}`}>
            {children}
        </div>
    );
}
